import { useEffect, useRef, useState } from "react"
import { I_midmileTrip } from "./types"
import { Apis } from "./apis"

type I_paging = { size: number, number: number, total: number }
export const useVehicles = (apis: Apis,setHub:(hub:{latitude:number,longitude:number,name:string})=>void) => {
    const [pageSize,setPageSize] = useState<number>(4)
    const pagingRef = useRef<I_paging>({ size: pageSize, number: 0, total: 0 })
    const allVehiclesRef = useRef<I_midmileTrip[]>([]);
    const [vehicles, _setVehicles] = useState<I_midmileTrip[]>([])
    const timeoutRef = useRef<any>(undefined)
    const [timer,setTimer] = useState<number>(15)
    const timerRef = useRef<number>(timer)
    timerRef.current = timer
    const changeTimer = (v:number)=>{
        setTimer(v)
    }
    const [auto, setAuto] = useState<boolean>(true)
    const toggleAuto = () => {
        const newAuto = !auto;
        if (newAuto) { startAuto() }
        else { clearTimeout(timeoutRef.current) }
        setAuto(newAuto)
    }
    const startAuto = (initial?: boolean) => {
        if (initial) {
            changePage();
            startAuto()
        }
        else {
            timeoutRef.current = setTimeout(() => {
                changePage();
                startAuto()
            }, timerRef.current * 1000)
        }
    }
    const reset = (total:number)=>{
        clearTimeout(timeoutRef.current)
        pagingRef.current = { ...pagingRef.current, total, number: 0 }
    }
    const fetchData = async () => {
        let vehicles = []
        let data = await apis.fetchTrips();
        if (data === false) { 
            vehicles = [] 
        }
        else {
            vehicles = data.vehicles
            setHub(data.currenthub)
        }
        reset(vehicles.length);
        allVehiclesRef.current = vehicles
        if(vehicles.length){startAuto(true)}
    }
    useEffect(() => {
        fetchData()
    }, [])
    const setVehicles = () => {
        const paging = pagingRef.current;
        const startIndex = (paging.number - 1) * paging.size
        const endIndex = startIndex + paging.size
        const newVehicles = allVehiclesRef.current.slice(startIndex, endIndex)
        _setVehicles(newVehicles.map((o, i) => ({ ...o, index: startIndex + i })))

    }
    const changePage = () => {
        const paging = pagingRef.current
        const pages = Math.ceil(paging.total / paging.size)
        if (!pages) { return }
        let newNumber = paging.number + 1;
        if (newNumber > pages) { newNumber = 1 }
        pagingRef.current = { ...pagingRef.current, number: newNumber }
        setVehicles()
    }
    const changePageSize = (size:number)=>{
        pagingRef.current = {...pagingRef.current,number:1,size}
        setPageSize(size)
        setVehicles()
    }
    return { changePage, vehicles, allVehicles: allVehiclesRef.current, fetchData, toggleAuto, auto,changeTimer,timer,pageSize,changePageSize }
}